import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { columns } from '../../../../scenes/IssuerDashboard/config';

const InvestorRelationsTable: FC = () => {
  // @ts-ignore:next-line
  const { relations = [] } = useSelector((root) => root.investor);

  const options = {
    pagination: false,
    selectableRows: undefined,
    filter: false,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    elevation: 0,
  };

  return <MUIDataTable title="" columns={columns} data={relations} options={options} />;
};

export default InvestorRelationsTable;
